import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { useCart } from '../../../context/CartContext';
import { UserProfile } from '../../../components/shared/UserProfile/UserProfile';
import { CartDrawer } from '../../../components/shared/CartDrawer/CartDrawer';
import './Navbar.css';

export const Navbar = ({ dark }) => {
  const { isAuthenticated, logout, user } = useAuth();
  const { cartItems, isCartOpen, setIsCartOpen, toggleCart } = useCart();

  return (
    <section className="navigation">
      <div className="nav mob">
        <Link
          to="/"
          className="logo-holder w-inline-block"
        >
          <img
            src={dark ? "/images/Asset-9.svg" : "/images/logo-light-svg.svg"}
            loading="lazy"
            alt="logo"
            className="logo"
          />
        </Link>
        <div className="acc-box">
          <img
            src={dark ? "/images/menu.svg" : "/images/menu-ico.svg"}
            loading="lazy"
            data-w-id="d52232ef-b362-22d1-c0e4-5692122e45aa"
            alt="burger menu"
            className="menu-icon"
          />
        </div>
      </div>
      <div className="nav">
        <Link
          to="/"
          className="logo-holder w-inline-block"
        >
          <img
            src={dark ? "/images/Asset-9.svg" : "/images/logo-light-svg.svg"}
            loading="lazy"
            alt="Hobi logo"
            className="logo"
          />
        </Link>
        <div className="acc-box">
          <Link to="/about" className={`nav-link ${dark ? 'dark' : ''}`}>
            About
          </Link>
          <Link to="/blogs" className={`nav-link ${dark ? 'dark' : ''}`}>
            Blogs
          </Link>
          <Link to="/for-business" className={`nav-link ${dark ? 'dark' : ''}`}>
            For Businesses
          </Link>
          {isAuthenticated ? (
            <div className="nav-auth-group" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
              {cartItems.length > 0 && (
                <div 
                  className="cart-indicator" 
                  onClick={toggleCart}
                  style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '5px',
                    color: 'black',
                    padding: '4px 10px',
                    borderRadius: '20px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    borderColor: 'gray',
                    borderStyle: 'solid',
                    borderWidth: '1px',
                  }}>
                  <span style={{ fontSize: '20px' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bag" viewBox="0 0 16 16">
  <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1m3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"/>
</svg>
                    </span> {cartItems.length}
                </div>
              )}
              <UserProfile user={user} size={38} />
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>

              <Link to="/login" className={`su-button ${dark ? 'dark' : ''} w-inline-block`}>
                <div className="text-block">Login</div>
              </Link>
            </div>
          )}
        </div>
      </div>
      <div className="mob-menu-container">
        <div className="acc-box mob-menu">
          <Link to="/about" className="nav-link mob-menu-txt">
            About
          </Link>
          <Link to="/blogs" className="nav-link mob-menu-txt">
            Blogs
          </Link>
          <Link to="/for-business" className="nav-link mob-menu-txt">
            For Businesses
          </Link>
          {isAuthenticated ? (
            <div className="nav-auth-group-mob">
              <UserProfile user={user} size={60} className="user-profile-trigger-mob" />
              <div className="su-button mob-menue-btn w-inline-block" style={{cursor: 'pointer'}}>
                <div className="text-block">View Profile</div>
              </div>
            </div>
          ) : (
            <Link to="/login" className="su-button mob-menue-btn w-inline-block">
              <div className="text-block">Login</div>
            </Link>
          )}
        </div>
        <img
          src="/images/close.svg"
          loading="lazy"
          data-w-id="d52232ef-b362-22d1-c0e4-5692122e45bf"
          alt="close"
          className="close"
        />
      </div>
      <CartDrawer 
        isOpen={isCartOpen} 
        onClose={() => setIsCartOpen(false)} 
        userId={user?.result?._id}
      />
    </section>
  );
};
